<template>
  <div>
    <el-table :data="items" v-loading="loading" size="small" class="mt-10">
      <el-table-column label="成品编号(分类)">
        <template slot-scope="scope"
          >{{ scope.row.p_code }}（{{ scope.row.p_name }}）</template
        >
      </el-table-column>
      <el-table-column align="center" label="拆检基地" prop="base_name">
      </el-table-column>
      <el-table-column align="center" label="拆检人" prop="user_name">
      </el-table-column>
      <el-table-column align="center" label="拆检日期" prop="disassemb_date">
      </el-table-column>
      <el-table-column align="center" label="缺失时间段">
        <template slot-scope="scope">
          {{ scope.row.assemb_date }} - {{ scope.row.disassemb_date }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    items: null,
    loading: false,
    category: Number,
  },
}
</script>